import { Button, Flex, Text, Textarea } from '@mantine/core';
import { useState } from 'react';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { GenericDrawer } from '@dealstack/frontend/shared/components/GenericDrawer/GenericDrawer';
import { useUpdateInvestorProcessSettings } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/api/useUpdateInvestorProcessSettings';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { HintBox } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/component/Review/component/styled';

interface Props {
	opened: boolean;
	onClose: () => void;
	activeInvestorId: string | undefined;
	kycWorkflowId?: string;
}

export const RequestAdditionalDocumentDrawer = ({
	opened,
	onClose,
	activeInvestorId,
	kycWorkflowId,
}: Props) => {
	const tMipManage = useTranslationMipManage();
	const [comment, setComment] = useState('');
	const [commentError, setCommentError] = useState('');

	const { handleRequestMorePivDocs, updateInvestorProcessSettingsRequest } =
		useUpdateInvestorProcessSettings({ activeInvestorId, kycWorkflowId });

	const handleClose = () => {
		setComment('');
		setCommentError('');
		onClose();
	};

	const handleSend = () => {
		if (!comment.trim()) {
			setCommentError(tMipManage('kyc.review.add_comment_error'));
			return;
		}
		handleRequestMorePivDocs(true, comment);
		handleClose();
	};

	return (
		<GenericDrawer
			opened={opened}
			onClose={handleClose}
			title={tMipManage('kyc.review.request_additional_file')}
			body={
				<Flex direction="column" gap="1rem" h="100%">
					<HintBox>
						<Icon variant="information" />
						<Text fw={600}>
							{tMipManage('kyc.review.request_additional_file_hint')}
						</Text>
					</HintBox>
					<Textarea
						value={comment}
						onChange={(e) => {
							setComment(e.target.value);
							if (commentError) {
								setCommentError('');
							}
						}}
						placeholder={tMipManage('kyc.review.reject_comment_placeholder')}
						error={commentError}
						label={tMipManage('kyc.review.add_comment')}
						withAsterisk
						autosize
						minRows={6}
						maxRows={12}
					/>
					<Flex direction="column" gap="0.5rem" mt="auto">
						<Button
							fullWidth
							onClick={handleSend}
							loading={updateInvestorProcessSettingsRequest.isPending}
						>
							{tMipManage('kyc.review.send')}
						</Button>
						<Button variant="default" fullWidth onClick={handleClose}>
							{tMipManage('kyc.review.cancel')}
						</Button>
					</Flex>
				</Flex>
			}
		/>
	);
};
